import React, { useRef } from 'react'
import Check from '../assets/svg/check.svg'
function CardCheckbox(props) {
    const checked = props.checked;
    const tooltipEl = useRef(null)

    return (

        <div onClick={() => { props.onClick()}}

            onMouseMove={(e) => {
                tooltipEl.current.style.display = "block"
                tooltipEl.current.style.left = e.clientX + 10 + "px"
                tooltipEl.current.style.top = e.clientY - 15 + "px"
            }}

            onMouseLeave={(e) => {
                tooltipEl.current.style.display = "none"
            }}

            className={`group relative px-3 hover:bg-primary hover:text-white pt-4 pb-2 m-2.5 w-60 min-h-35 font-semibold 2xl:w-77.5 2xl:min-h-45  2xl:text-xl flex items-center text-center justify-center rounded-md border border-primary ${checked ? "bg-primary text-white" : "bg-white"} cursor-pointer`}>
            <div className="rounded-full w-6.5 h-4 border border-primary bg-white absolute right-0 top-0 mr-2 mt-2 flex justify-center items-center">

                {checked ? <img src={Check} alt="" /> : ""}
            </div>
            {props.text}
            <div ref={tooltipEl} className="fixed text-xxs bg-gray-700 bg-opacity-90 leading-none rounded p-2 text-white z-10" style={{ display: "none" }}>Multiple Selection</div>
        </div>
    )
}


export default CardCheckbox

